import React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { LoginContainer } from "components/Login";
import { ShowcaseSignupForm } from "components/ShowcaseSignup";
import { CLOUDFRONT_URL } from "constants/index";

/**
 * Showcase Signup
 */
const ShowcaseSignup = () => {
  const intl = useIntl();
  const selectedBanner = banners(intl)[0];

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Signup.Title" })}</title>
      </Helmet>
      <LoginContainer banner={selectedBanner}>
        <ShowcaseSignupForm />
      </LoginContainer>
    </>
  );
};

const banners = (intl) => [
  {
    type: "video",
    title: intl.formatMessage({ id: "Signup.Banner.Showcase.Title" }),
    cover: `${CLOUDFRONT_URL}videos/demos/demo_talent_search.m4v`,
  },
];

export default ShowcaseSignup;
